
export enum TipoSincronismoEnum {
  Download = 'Download',
  Upload = 'Upload',
}
